<template>
  <v-app class="site">

    <!-- =====================================================
         HEADER
    ====================================================== -->

    <header class="header">

      <div class="header-inner">

        <!-- LOGO -->
        <router-link
          to="/"
          class="logo"
          aria-label="Zur Startseite"
        >
          <img
            :src="logo"
            alt="TR Hygieneprofis"
          />
        </router-link>

        <!-- NAVIGATION -->

        <nav class="navigation">

          <router-link
            to="/leistungen"
            class="navbar-link"
          >
            Leistungen
          </router-link>

          <router-link
            to="/branchen"
            class="navbar-link"
          >
            Branchen
          </router-link>

          <router-link
            to="/wissen"
            class="navbar-link"
          >
            Wissen
          </router-link>

          <router-link
            to="/overUsChoose"
            class="navbar-link"
          >
            Über uns
          </router-link>

          <router-link
            to="/kontakt"
            class="navbar-link"
          >
            Kontakt
          </router-link>

          <!-- Beratung anfragen → E-Mail -->

          <a
            href="mailto:info@tr-hygieneprofis.de"
            class="header-button"
          >
            <span>
              Beratung anfragen
            </span>

            <v-icon size="17">
              mdi-arrow-right
            </v-icon>
          </a>

        </nav>

      </div>

    </header>


    <!-- =====================================================
         SEITENINHALT
    ====================================================== -->

    <v-main>
      <router-view />

    </v-main>


    <!-- =====================================================
         FOOTER
    ====================================================== -->

    <footer class="footer">

      <div class="footer-container">


        <!-- =================================================
             LOGO → STARTSEITE
        ================================================== -->

        <router-link
          to="/"
          class="footer-logo-link"
          aria-label="Zur Startseite"
        >

          <v-img
            :src="logo"
            alt="TR Hygieneprofis"
            class="footer-logo"
          />

        </router-link>


        <!-- =================================================
             TELEFON
        ================================================== -->

        <div class="footer-item">

          <v-icon size="21">
            mdi-phone-outline
          </v-icon>

          <span>

            <a
              href="tel:+4917070088346"
              style="color: inherit; text-decoration: none;"
            >
              +49 176 31154230 
            </a>

          </span>

        </div>


        <!-- =================================================
             E-MAIL
        ================================================== -->

        <div class="footer-item">

          <v-icon size="21">
            mdi-email-outline
          </v-icon>

          <span>

            <a
              href="mailto:info@tr-hygieneprofis.de"
              class="email-link"
            >
              info@tr-hygieneprofis.de
            </a>

          </span>

        </div>


        <!-- =================================================
             LINKS
        ================================================== -->

        <div class="footer-links">

          <router-link
            to="/impressum"
            class="footer-link"
          >
            Impressum
          </router-link>

          <router-link
            to="/datenschutz"
            class="footer-link"
          >
            Datenschutz
          </router-link>

        </div>

      </div>

    </footer>

  </v-app>
</template>


<script setup>

import logo from './assets/mainLogo.png'


</script>


<style scoped>

/* ============================================================
   GLOBAL
============================================================ */

:global(*) {
  box-sizing: border-box;
}

:global(html) {
  scroll-behavior: smooth;
}

:global(body) {
  margin: 0;
  padding: 0;

  font-family:
    Arial,
    Helvetica,
    sans-serif;

  color: #111111;

  background: #ffffff;
}

:global(a) {
  text-decoration: none;
}


/* ============================================================
   APP
============================================================ */

.site {
  --green: #72b82a;
  --green-dark: #63a91d;
  --black: #0a0a0a;

  background: #ffffff;
}


/* ============================================================
   HEADER
============================================================ */

.header {
  width: 100%;
  height: 82px;

  background: #ffffff;

  position: relative;
  z-index: 100;
}

.header-inner {
  width: calc(100% - 68px);
  max-width: 1440px;

  height: 82px;

  margin: 0 auto;

  display: flex;
  align-items: center;
  justify-content: space-between;
}


/* ============================================================
   LOGO
============================================================ */

.logo {
  display: flex;
  align-items: center;

  text-decoration: none;

  cursor: pointer;
}

.logo img {
  width: 238px;
  height: auto;
  display: block;
}

.logo:hover {
  opacity: 0.85;
}


/* ============================================================
   NAVIGATION
============================================================ */

.navigation {
  display: flex;
  align-items: center;
  gap: 38px;
}

.navigation > a,
.navigation > .navbar-link {
  color: #111111;

  font-size: 13px;
  font-weight: 600;

  white-space: nowrap;

  transition: 0.2s ease;

  text-decoration: none;
}

.navigation > a:hover,
.navigation > .navbar-link:hover {
  color: var(--green);
}


/* ============================================================
   HEADER BUTTON
============================================================ */

.header-button {
  width: 170px;
  height: 40px;

  padding: 0 14px;

  border: 1px solid var(--green);

  color: var(--green) !important;

  display: flex;
  align-items: center;
  justify-content: space-between;

  font-size: 12px !important;
  font-weight: 600 !important;

  transition: 0.2s ease;
}

.header-button:hover {
  background: var(--green);
  color: #ffffff !important;
}

/* ============================================================
   FOOTER
============================================================ */

.footer {
  width: 100%;

  height: 75px;

  background: #ffffff;
}

.footer-container {
  width: calc(100% - 100px);

  max-width: 1190px;

  height: 75px;

  margin: 0 auto;

  display: flex;

  align-items: center;

  justify-content: space-between;

  gap: 25px;
}


/* ============================================================
   FOOTER LOGO
============================================================ */

.footer-logo-link {
  display: flex;

  align-items: center;

  justify-content: center;

  text-decoration: none;

  cursor: pointer;

  transition:
    opacity 0.2s ease,
    transform 0.2s ease;
}

.footer-logo-link:hover {
  opacity: 0.85;

  transform: translateY(-1px);
}

.footer-logo {
  width: 180px;

  height: auto;

  display: block;
}


/* ============================================================
   FOOTER KONTAKT
============================================================ */

.footer-item {
  display: flex;

  align-items: center;

  gap: 10px;

  color: #111111;

  font-size: 10.5px;
}

.footer-item .v-icon {
  color: var(--green);
}


/* ============================================================
   FOOTER LINKS
============================================================ */

.footer-links {
  display: flex;

  align-items: center;

  gap: 38px;
}

.footer-links a {
  color: #111111;

  font-size: 10px;

  text-decoration: none;

  transition: color 0.2s ease;
}

.footer-links a:hover {
  color: var(--green);
}


/* ============================================================
   E-MAIL
============================================================ */

.email-link {
  color: #00a8c8;

  text-decoration: none;

  transition: color 0.2s ease;
}

.email-link:hover {
  color: var(--green);
}


/* ============================================================
   TABLET
============================================================ */

@media (max-width: 1200px) {

  .header-inner,
  .hero-container,
  .content,
  .information-inner {
    width: calc(100% - 50px);
  }

  .navigation {
    gap: 20px;
  }

  .navigation > a,
  .navigation > .navbar-link {
    font-size: 11px;
  }

  .header-button {
    width: 145px;
  }

  .hero-background {
    left: 27%;
    width: 73%;
    object-position: center center;
  }

  .hero-gradient {
    width: 48%;
  }

  .usp-wrapper {
    width: calc(100% - 90px);
  }

  .cta-container {
    width: calc(100% - 100px);
  }

}


/* ============================================================
   MOBILE
============================================================ */

@media (max-width: 760px) {

  /* ==========================================================
     GLOBAL MOBILE
  ========================================================== */

  :global(body) {
    width: 100%;
    overflow-x: hidden;
  }

  .site {
    width: 100%;
    overflow-x: hidden;
  }


  /* ==========================================================
     HEADER
  ========================================================== */

  .header {
    height: 72px;
    width: 100%;
  }

  .header-inner {
    width: calc(100% - 30px);
    height: 72px;

    margin: 0 auto;

    padding: 0;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .logo {
    flex-shrink: 0;
  }

  .logo img {
    width: 175px;
    height: auto;
    display: block;
  }

  .navigation {
    display: none;
  }


  /* ==========================================================
     HERO – MOBIL
  ========================================================== */

  .hero {
    width: 100%;
    height: auto;
    min-height: 0;

    position: relative;

    overflow: visible;

    background: #ffffff;

    display: flex;
    flex-direction: column;
  }

  .hero-background {
    position: relative;

    top: auto;
    left: auto;

    width: 100%;
    height: 330px;

    display: block;

    object-fit: cover;

    object-position: 70% center;

    z-index: 1;

    flex-shrink: 0;
  }

  .hero-gradient {
    position: absolute;

    top: 0;
    left: 0;

    width: 100%;
    height: 330px;

    z-index: 2;

    pointer-events: none;

    background: linear-gradient(
      180deg,
      rgba(255,255,255,0) 0%,
      rgba(255,255,255,0) 55%,
      rgba(255,255,255,0.12) 70%,
      rgba(255,255,255,0.55) 88%,
      rgba(255,255,255,0.90) 97%,
      rgba(255,255,255,1) 100%
    );
  }

  .hero-container {
    width: 100%;
    height: auto;

    margin: 0;

    position: relative;
    z-index: 5;

    display: block;
  }

  .hero-text {
    position: relative;

    top: auto;
    left: auto;

    width: calc(100% - 40px);

    margin: 0 auto;

    padding-top: 28px;
    padding-bottom: 30px;

    z-index: 10;

    background: #ffffff;
  }

  .hero-small-title {
    color: var(--green);

    font-size: 11px;
    line-height: 1.4;
    font-weight: 700;

    margin-bottom: 12px;
  }

  .hero-text h1 {
    margin: 0;

    color: #101010;

    font-size: 34px;
    line-height: 1.12;

    font-weight: 700;

    letter-spacing: -0.5px;
  }

  .hero-text h1 span {
    color: var(--green);
  }

  .hero-text .green-line {
    width: 36px;
    height: 2px;

    margin-top: 18px;
    margin-bottom: 18px;

    background: var(--green);
  }

  .hero-text > p {
    width: 100%;

    margin: 0;

    color: #111111;

    font-size: 13px;
    line-height: 1.75;
  }

  .hero-button {
    width: 100%;
    max-width: 250px;

    height: 46px;

    margin-top: 22px;

    padding: 0 17px;

    font-size: 11px;

    display: flex;
    align-items: center;
    justify-content: space-between;

    background: var(--green);

    color: #ffffff;
  }


  /* ==========================================================
     USP
  ========================================================== */

  .usp-wrapper {
    position: relative;

    left: auto;
    bottom: auto;

    transform: none;

    width: calc(100% - 30px);

    margin: 0 auto;

    z-index: 30;
  }

  .usp-container {
    width: 100%;

    min-height: auto;

    padding: 5px;

    border-radius: 10px;

    grid-template-columns: 1fr 1fr;

    box-shadow: 0 5px 20px rgba(0,0,0,0.08);
  }

  .usp {
    min-height: 145px;

    padding: 15px 8px;

    border-right: 1px solid #e1e1e1;

    border-bottom: 1px solid #e1e1e1;
  }

  .usp:nth-child(2n) {
    border-right: none;
  }

  .usp:nth-child(3),
  .usp:nth-child(4) {
    border-bottom: none;
  }

  .usp-icon {
    height: 45px;

    margin-bottom: 6px;
  }

  .usp-icon .v-icon {
    font-size: 37px !important;
  }

  .usp h3 {
    margin: 0 0 9px;

    font-size: 10px;

    line-height: 1.25;
  }

  .usp p {
    margin: 0;

    font-size: 9px;

    line-height: 1.55;
  }


  /* ==========================================================
     LEISTUNGEN
  ========================================================== */

  .services {
    padding-top: 55px;
    padding-bottom: 35px;

    background: #ffffff;
  }

  .content {
    width: calc(100% - 30px);

    margin: 0 auto;
  }

  .section-title {
    margin-bottom: 30px;
  }

  .section-title h2 {
    font-size: 22px;

    line-height: 1.2;
  }

  .section-title p {
    font-size: 11px;

    line-height: 1.65;

    max-width: 340px;

    margin-left: auto;
    margin-right: auto;
  }

  .section-title p br {
    display: none;
  }

  .services-list {
    width: 100%;

    display: grid;

    grid-template-columns: 1fr 1fr;

    row-gap: 30px;

    column-gap: 0;
  }

  .service {
    min-height: 110px;

    padding: 0 8px;

    border: none !important;

    display: flex;

    align-items: center;

    justify-content: flex-start;

    text-align: center;
  }

  .service .v-icon {
    color: var(--green);

    margin-bottom: 10px;

    font-size: 40px !important;
  }

  .service h3 {
    margin: 0;

    font-size: 10px;

    line-height: 1.4;

    font-weight: 700;
  }

  .services-button-wrapper {
    margin-top: 30px;

    display: flex;

    justify-content: center;
  }

  .outline-button {
    width: 240px;

    height: 42px;

    font-size: 11px;
  }


  /* ==========================================================
     INFORMATION – MOBIL
  ========================================================== */

  .information {
    width: 100%;

    height: auto;

    min-height: 0;

    position: relative;

    overflow: visible;

    background: #f3f3f0;

    display: flex;

    flex-direction: column;
  }

  .information-image {
    position: relative;

    left: auto;
    right: auto;
    top: auto;
    bottom: auto;

    order: 1;

    width: 100%;

    height: auto;

    min-height: 0;

    overflow: hidden;

    opacity: 1;

    z-index: 1;

    flex-shrink: 0;
  }

  .information-image::before {
    display: none;
  }

  .information-image img {
    position: relative;

    inset: auto;

    width: 100%;

    height: auto;

    display: block;

    object-fit: contain;

    object-position: center center;

    background: #f3f3f0;
  }

  .information-content {
    position: relative;

    order: 2;

    z-index: 5;

    width: 100%;

    height: auto;

    background: #f3f3f0;
  }

  .information-inner {
    width: calc(100% - 40px);

    height: auto;

    margin: 0 auto;

    padding-top: 35px;

    padding-bottom: 35px;
  }

  .information-inner h2 {
    margin: 0;

    font-size: 28px;

    line-height: 1.2;

    font-weight: 700;
  }

  .information-inner h2 span {
    color: var(--green);
  }

  .information-inner .green-line {
    margin-top: 18px;

    margin-bottom: 18px;
  }

  .information-inner p {
    width: 100%;

    max-width: 340px;

    margin: 0;

    font-size: 12px;

    line-height: 1.7;
  }

  .text-link {
    margin-top: 15px;

    font-size: 11px;
  }


  /* ==========================================================
     CTA
  ========================================================== */

  .cta {
    width: 100%;

    height: auto;

    min-height: 290px;

    padding: 35px 0;
  }

  .cta-container {
    width: calc(100% - 40px);

    max-width: none;

    height: auto;

    margin: 0 auto;

    display: flex;

    flex-direction: column;

    align-items: flex-start;

    justify-content: center;

    gap: 18px;
  }

  .cta-shield {
    display: none;
  }

  .cta-text {
    width: 100%;

    margin-left: 0;
  }

  .cta-text h2 {
    font-size: 28px;

    line-height: 1.05;
  }

  .cta-text p {
    max-width: 320px;

    margin-top: 10px;

    font-size: 11px;

    line-height: 1.6;
  }

  .cta-button {
    width: 100%;

    max-width: 300px;

    height: 45px;

    font-size: 11px;
  }


  /* ==========================================================
     FOOTER
  ========================================================== */

  .footer {
    width: 100%;

    height: auto;

    background: #ffffff;
  }

  .footer-container {
    width: calc(100% - 40px);

    height: auto;

    margin: 0 auto;

    padding: 30px 0;

    display: flex;

    flex-direction: column;

    align-items: flex-start;

    justify-content: flex-start;

    gap: 20px;
  }

  .footer-logo-link {
    display: flex;

    align-items: center;

    justify-content: flex-start;

    text-decoration: none;
  }

  .footer-logo {
    width: 190px;

    height: auto;
  }

  .footer-item {
    display: flex;

    align-items: center;

    gap: 10px;

    font-size: 11px;

    width: 100%;
  }

  .footer-links {
    width: 100%;

    display: flex;

    align-items: center;

    gap: 25px;

    padding-top: 5px;
  }

  .footer-links a {
    font-size: 11px;
  }

}


/* ============================================================
   SEHR KLEINE GERÄTE
============================================================ */

@media (max-width: 450px) {

  .header {
    height: 65px;
  }

  .header-inner {
    height: 65px;

    width: calc(100% - 24px);
  }

  .logo img {
    width: 155px;
  }


  /* ==========================================================
     HERO – SEHR KLEINE SMARTPHONES
  ========================================================== */

  .hero {
    min-height: 0;

    height: auto;
  }

  .hero-background {
    width: 100%;

    height: 300px;

    object-fit: cover;

    object-position: 70% center;
  }

  .hero-gradient {
    height: 300px;
  }

  .hero-text {
    width: calc(100% - 30px);

    margin: 0 auto;

    padding-top: 25px;

    padding-bottom: 28px;
  }

  .hero-small-title {
    font-size: 10px;

    margin-bottom: 10px;
  }

  .hero-text h1 {
    font-size: 29px;

    line-height: 1.13;
  }

  .hero-text > p {
    font-size: 11px;

    line-height: 1.7;
  }

  .hero-button {
    max-width: 240px;

    height: 44px;

    font-size: 10px;
  }


  /* ==========================================================
     USP
  ========================================================== */

  .usp-wrapper {
    width: calc(100% - 20px);
  }

  .usp {
    min-height: 130px;

    padding: 12px 5px;
  }

  .usp-icon {
    height: 40px;
  }

  .usp-icon .v-icon {
    font-size: 34px !important;
  }

  .usp h3 {
    font-size: 9px;

    margin-bottom: 7px;
  }

  .usp p {
    font-size: 8px;

    line-height: 1.5;
  }


  /* ==========================================================
     LEISTUNGEN
  ========================================================== */

  .services {
    padding-top: 45px;
  }

  .content {
    width: calc(100% - 24px);
  }

  .section-title h2 {
    font-size: 20px;
  }

  .section-title p {
    font-size: 10px;
  }

  .services-list {
    grid-template-columns: 1fr 1fr;

    row-gap: 25px;
  }

  .service {
    min-height: 100px;

    padding: 0 5px;
  }

  .service .v-icon {
    font-size: 36px !important;
  }

  .service h3 {
    font-size: 9px;

    line-height: 1.35;
  }

  .outline-button {
    width: 220px;

    height: 40px;

    font-size: 10px;
  }


  /* ==========================================================
     INFORMATION
  ========================================================== */

  .information {
    height: auto;

    min-height: 0;
  }

  .information-image {
    width: 100%;

    height: auto;
  }

  .information-image img {
    width: 100%;

    height: auto;

    object-fit: contain;

    object-position: center center;
  }

  .information-inner {
    width: calc(100% - 30px);

    padding-top: 30px;

    padding-bottom: 30px;
  }

  .information-inner h2 {
    font-size: 26px;
  }

  .information-inner p {
    font-size: 11px;
  }


  /* ==========================================================
     CTA
  ========================================================== */

  .cta {
    min-height: 270px;

    padding: 30px 0;
  }

  .cta-container {
    width: calc(100% - 30px);
  }

  .cta-text h2 {
    font-size: 25px;
  }

  .cta-text p {
    font-size: 10px;
  }

  .cta-button {
    max-width: 100%;

    height: 43px;
  }


  /* ==========================================================
     FOOTER
  ========================================================== */

  .footer-container {
    width: calc(100% - 30px);

    padding: 25px 0;
  }

  .footer-logo-link {
    display: flex;

    align-items: center;

    justify-content: flex-start;
  }

  .footer-logo {
    width: 170px;
  }

  .footer-item {
    font-size: 10px;
  }

  .footer-links a {
    font-size: 10px;
  }

}


/* ============================================================
   MOBILE NAVIGATION – ALLE NAVBAR-MENÜPUNKTE SICHTBAR
   Bestehender Inhalt bleibt vollständig erhalten.
   Die Navigation wird auf Mobilgeräten unter dem Logo
   vollständig angezeigt und erzeugt keinen Überlauf.
============================================================ */

@media (max-width: 760px) {

  .header {
    height: auto !important;
    min-height: 72px !important;
    width: 100% !important;
  }

  .header-inner {
    width: calc(100% - 30px) !important;
    height: auto !important;
    min-height: 72px !important;
    margin: 0 auto !important;
    padding: 12px 0 14px !important;

    display: flex !important;
    flex-direction: column !important;
    align-items: stretch !important;
    justify-content: flex-start !important;
    gap: 12px !important;
  }

  .logo {
    width: 100% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    flex-shrink: 0 !important;
  }

  .logo img {
    width: 175px !important;
    max-width: 100% !important;
    height: auto !important;
    display: block !important;
  }

  /*
     Die komplette Desktop-Navigation bleibt auch mobil erhalten.
     Alle fünf Menüpunkte und "Beratung anfragen" werden angezeigt.
  */
  .navigation {
    width: 100% !important;
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 8px !important;
    align-items: stretch !important;
    justify-content: stretch !important;
  }

  .navigation > a,
  .navigation > .navbar-link {
    width: 100% !important;
    min-width: 0 !important;
    min-height: 38px !important;
    padding: 8px 6px !important;

    display: flex !important;
    align-items: center !important;
    justify-content: center !important;

    color: #111111 !important;
    background: #ffffff !important;
    border: 1px solid #e7e7e7 !important;
    border-radius: 2px !important;

    font-size: 11px !important;
    line-height: 1.2 !important;
    font-weight: 600 !important;
    text-align: center !important;
    white-space: normal !important;

    box-sizing: border-box !important;
  }

  .navigation > a:hover,
  .navigation > .navbar-link:hover {
    color: var(--green) !important;
    border-color: var(--green) !important;
    background: #ffffff !important;
  }

  /*
     Der Beratungs-Button steht über die komplette Breite
     der mobilen Navigation.
  */
  .navigation > .header-button {
    grid-column: 1 / -1 !important;

    width: 100% !important;
    min-height: 42px !important;
    height: 42px !important;

    margin: 0 !important;
    padding: 0 14px !important;

    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;

    border: 1px solid var(--green) !important;
    background: #ffffff !important;
    color: var(--green) !important;

    font-size: 11px !important;
    line-height: 1.2 !important;
    font-weight: 600 !important;
  }

  .navigation > .header-button:hover {
    background: var(--green) !important;
    color: #ffffff !important;
  }
}

@media (max-width: 450px) {

  .header-inner {
    width: calc(100% - 24px) !important;
    padding: 10px 0 12px !important;
    gap: 10px !important;
  }

  .logo img {
    width: 155px !important;
  }

  .navigation {
    gap: 6px !important;
  }

  .navigation > a,
  .navigation > .navbar-link {
    min-height: 36px !important;
    padding: 7px 4px !important;
    font-size: 10px !important;
  }

  .navigation > .header-button {
    min-height: 40px !important;
    height: 40px !important;
    font-size: 10px !important;
  }
}


/* ============================================================
   MOBILE NAVIGATION – DESKTOP-STYLE
   Die vorhandene Navigation bleibt vollständig erhalten.
   Auf Mobilgeräten wird nur die Darstellung an den Desktop-
   Stil angepasst:
   - keine Karten-/Kastenoptik bei den Menüpunkten
   - schwarzer Text
   - gleiche Schriftwirkung wie Desktop
   - grüner Hover-Effekt
   - nur "Beratung anfragen" erhält den grünen Rahmen
============================================================ */

@media (max-width: 760px) {

  .header {
    height: auto !important;
    min-height: 72px !important;
  }

  .header-inner {
    width: calc(100% - 30px) !important;
    height: auto !important;
    min-height: 72px !important;

    padding: 12px 0 14px !important;

    display: flex !important;
    flex-direction: column !important;
    align-items: stretch !important;
    justify-content: flex-start !important;
    gap: 12px !important;
  }

  .logo {
    width: 100% !important;
    justify-content: center !important;
  }

  .logo img {
    width: 175px !important;
    height: auto !important;
  }

  /*
     Die Navigation bleibt vollständig sichtbar.
     Sie darf auf kleinen Displays in mehrere Zeilen umbrechen,
     behält aber die Optik der Desktop-Navigation.
  */
  .navigation {
    width: 100% !important;

    display: flex !important;
    flex-wrap: wrap !important;

    align-items: center !important;
    justify-content: center !important;

    gap: 8px 24px !important;

    margin: 0 !important;
    padding: 0 !important;
  }

  /*
     Normale Menüpunkte:
     exakt die schlichte Desktop-Optik – kein Rahmen,
     kein Hintergrund und keine Box.
  */
  .navigation > a:not(.header-button),
  .navigation > .navbar-link {
    width: auto !important;
    min-width: auto !important;
    min-height: 38px !important;

    margin: 0 !important;
    padding: 8px 0 !important;

    display: flex !important;
    align-items: center !important;
    justify-content: center !important;

    border: none !important;
    border-radius: 0 !important;

    background: transparent !important;

    color: #111111 !important;

    font-size: 13px !important;
    line-height: 1.2 !important;
    font-weight: 600 !important;

    text-align: center !important;
    white-space: nowrap !important;

    box-sizing: border-box !important;

    transition: color 0.2s ease !important;
  }

  .navigation > a:not(.header-button):hover,
  .navigation > .navbar-link:hover {
    border: none !important;
    background: transparent !important;
    color: var(--green) !important;
  }

  /*
     Beratung anfragen:
     gleiche Optik wie Desktop.
  */
  .navigation > .header-button {
    width: 170px !important;
    min-width: 170px !important;
    height: 40px !important;
    min-height: 40px !important;

    margin: 0 !important;
    padding: 0 14px !important;

    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;

    border: 1px solid var(--green) !important;
    border-radius: 0 !important;

    background: #ffffff !important;
    color: var(--green) !important;

    font-size: 12px !important;
    line-height: 1.2 !important;
    font-weight: 600 !important;

    white-space: nowrap !important;

    transition:
      background 0.2s ease,
      color 0.2s ease !important;
  }

  .navigation > .header-button:hover {
    background: var(--green) !important;
    color: #ffffff !important;
  }

  .navigation > .header-button .v-icon {
    color: inherit !important;
  }
}

@media (max-width: 450px) {

  .header-inner {
    width: calc(100% - 24px) !important;
    padding: 10px 0 12px !important;
    gap: 10px !important;
  }

  .logo img {
    width: 155px !important;
  }

  /*
     Auch auf sehr kleinen Smartphones bleibt die Desktop-
     Optik erhalten. Die Menüpunkte dürfen umbrechen.
  */
  .navigation {
    gap: 4px 18px !important;
  }

  .navigation > a:not(.header-button),
  .navigation > .navbar-link {
    min-height: 34px !important;
    padding: 7px 0 !important;

    font-size: 12px !important;
    font-weight: 600 !important;
  }

  .navigation > .header-button {
    width: 170px !important;
    min-width: 170px !important;

    height: 40px !important;
    min-height: 40px !important;

    font-size: 12px !important;
  }
}
</style>